import axios from "axios";
import { API_MODULE } from "@env";

export const getReportStatistic = (id, clientName, reportMode) => {
  if (clientName != "" && reportMode != "") {
    return axios.get(`${API_MODULE}/data-statistic/${encodeURIComponent(id)}?mode=${encodeURIComponent(clientName)}&report=${encodeURIComponent(reportMode)}`);
  }

  return axios.get(`${API_MODULE}/data-statistic/${encodeURIComponent(id)}`);
}